export var INIT_LOAD_MANAGER_EVENT_NAME = 'INIT_LOAD_MANAGER_EVENT_NAME';
